import React, {useState} from "react";

import moment from "moment";
import Pagination from "react-js-pagination";
import Unavailable from "./UnavailableModel";
import {convertDateAndTimeTimezonelll} from "../../../utility/utility";
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import "./pagination.css";
const SearchResult = ({searchHistory, user,...props}) => {
  const [currentSchedule, setCurrentSchedule] = useState({});
  const [commentTask, setCommentTask] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(null);
  return(
      <>
      <div className="appcontent_Inner">
        {searchHistory ? <Unavailable {...props} currentSchedule={currentSchedule} setCurrentSchedule={setCurrentSchedule}></Unavailable> : ""}
        <div className="history_block min-height-75">
           <div className="row mb-3 mt-3">
            <div className="col-12 d-flex justify-content-center justify-content-md-end">
            {user && (
              <button className="csv_btn btn_danger float-none" onClick={() => props.exportCleaningHistory({ start_date:null, end_date:null, area_id:null },props.match.params.accountId)} >Export CSV</button>
            )}
            </div>
        </div>  
          <div className="add_content_block">
            <h2 className="h3_title"><span className="title_block">History
              {
                searchHistory && searchHistory.frontline_tasks && (props.search.area_name && props.search.area_type_id && props.search.floor_id && props.searched) && <button className="new_search-desktop btn btn_danger float-right" onClick={() => props.history.push(`/account/${props.match.params.accountId}/schedule`)}>View Schedule</button>
              }
            </span> <span className="mob_border_view"><span className="cst_border"></span></span></h2>
              <ol className="activity-feed">
                {
                  searchHistory && searchHistory.frontline_tasks ? Object.keys(searchHistory.frontline_tasks).map((key, index) => {
                    return searchHistory.frontline_tasks[key]["frontline_tasks"].map((task, index) => {
                      return (<li key={index} className="feed-item timeline_item">
                        <div className="d-flex justify-content-between align-items-center">
                        {
                          (task.status === "not_available" && user && ["superadmin", "admin"].includes(user.role)) ?
                              <span className="list_content">
                                <span className="font-weight-semibold">{task.area.name}</span>{` was `}
                                <strong className="sm_title text_danger">{`In-use `}</strong>{`at `}
                                <span className="font-weight-semibold">
                                  {
                                    task.scanned_at ?   convertDateAndTimeTimezonelll(task.scanned_at, searchHistory.timezone) :  convertDateAndTimeTimezonelll(task.captured_time, searchHistory.timezone)
                                  }
                                </span>
                                <span data-toggle="modal" onClick={() => setCurrentSchedule(task)} data-target="#setUnavailable" className="info_icon">
                                  {" "}<img src="/images/icons/info.png" alt="Image" />
                                </span>
                              </span>
                              :
                              <span className="list_content">
                                <span className="font-weight-semibold">{task.area.name}</span>
                                {task.status === "not_cleaned" ? ` not cleaned on ` : ` cleaned on `}
                                <span className="font-weight-semibold">
                                  {
                                    task.scanned_at ? convertDateAndTimeTimezonelll(task.scanned_at, searchHistory.timezone) :  convertDateAndTimeTimezonelll(task.captured_time, searchHistory.timezone)
                                  }
                                </span>
                              </span>
                        }
                          {task.area && task.area.enable_frontline_comment && task.frontline_comment && user && ["superadmin", "admin"].includes(user.role) && (
                            <span className="account_edit_icn ml-3" onClick={() => setCommentTask(task)}><i className="fas fa-eye cst_icon" aria-hidden="true"></i></span>
                          )}
                        </div>
                      </li>)
                    })
                  }) : "No records found"
                }
              </ol>
              <div className="row">
                <nav aria-label="Page navigation example" className="history-pagination col-12">

                {
                  searchHistory &&  searchHistory.frontline_tasks && props.total_no_of_pages ? <Pagination
                      activePage={props.search.page}
                      className="float-right"
                      itemsCountPerPage={props.search.size}
                      totalItemsCount={props.search.size * props.total_no_of_pages}
                      pageRangeDisplayed={5}
                      onChange={props.handlePageChange}
                      /> : ""
                }
                  </nav>
              </div>
            </div>
          </div>
        </div>

      {commentTask && (
        <Dialog
          open={!!commentTask}
          onClose={(_, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') setCommentTask(null);
          }}
          aria-labelledby="frontline-comment-view-dialog"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <div className="comments_wrap">
              <div className="form-group">
                <span className="form_title">Area Name: </span>
                <span>{commentTask.area && commentTask.area.name}</span>
              </div>
              <div className="form-group">
                <span className="form_title">QR Scanned Date &amp; Time: </span>
                <span>
                  {commentTask.scanned_at
                    ? convertDateAndTimeTimezonelll(commentTask.scanned_at, searchHistory.timezone)
                    : convertDateAndTimeTimezonelll(commentTask.captured_time, searchHistory.timezone)}
                </span>
              </div>
              <div className="form-group">
                <span className="form_title">Comment: </span>
                <span>
                  {commentTask.frontline_comment && commentTask.frontline_comment.comment
                    ? commentTask.frontline_comment.comment
                    : <span className="text-muted">—</span>}
                </span>
              </div>
              {commentTask.frontline_comment && commentTask.frontline_comment.attachments && commentTask.frontline_comment.attachments.length > 0 && (
                <div className="form-group mb-0">
                  <span className="form_title d-block mb-2">Photo Attachments:</span>
                  <div className="upload_file fcm-upload-file">
                    <div className="row fcm-preview-row">
                      {commentTask.frontline_comment.attachments.map((att, i) => (
                        <div className="col-4 col-sm-4 px-2 mb-2" key={i}>
                          <div
                            className="fcm-file-view-clickable"
                            onClick={() => setLightboxImage(att.photo_urls && att.photo_urls.original)}
                          >
                            <img
                              src={att.photo_urls && att.photo_urls.small}
                              alt={`attachment ${i + 1}`}
                              className="fcm-thumbnail-img w-100"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions className="modal-footer">
            <button
              type="button"
              className="btn btn_danger cst_btn"
              onClick={() => setCommentTask(null)}
            >Close</button>
          </DialogActions>
        </Dialog>
      )}

      <Dialog
        open={!!lightboxImage}
        onClose={() => setLightboxImage(null)}
        aria-labelledby="history-lightbox-dialog"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="history-lightbox-dialog" className="fcm-lightbox-title">
          <div className="fcm-lightbox-close-wrapper">
            <button
              type="button"
              onClick={() => setLightboxImage(null)}
              className="fcm-lightbox-close-btn"
              aria-label="Close"
            >&times;</button>
          </div>
        </DialogTitle>
        <DialogContent className="fcm-lightbox-content">
          {lightboxImage && (
            <img src={lightboxImage} alt="Full size preview" className="fcm-lightbox-img" />
          )}
        </DialogContent>
      </Dialog>
      </>
  )
};

export default SearchResult;